/**
 * Avatar fallback letter. Strips bracketed segments ("[QA]", "[CTO]")
 * so the initial reads "A" / "S" instead of "[" for users whose display
 * name is "[QA] Andrey" / "[CTO] Sergey". If the name is entirely a
 * bracketed tag (e.g. just "[Bot]") returns '?' rather than the bracket
 * — per OSPROD-87 brackets must never surface as an avatar letter.
 *
 * Returns an uppercase letter, or '?' for empty/missing/bracket-only input.
 */
export function displayInitial(name: string | null | undefined): string {
  if (!name) return '?'
  const stripped = name.replace(/\[[^\]]*\]/g, '').trim()
  return (stripped[0] || '?').toUpperCase()
}
